import React from 'react';
import T from 'prop-types';
// styles
import classnames from 'classnames/bind';
import styles from './Indicator.module.scss';

const cx = classnames.bind(styles);

const WarningIndicator = ({ className }) => {
  return <div className={cx('wrapper', 'warning', className)}>!</div>;
};

WarningIndicator.propTypes = {
  className: T.oneOfType([T.func, T.string]),
};

export default WarningIndicator;
